import composter from "../res/composter.jpg";

function Composter(){
    return(
        <div className = "flexwrap margin">
            <div className="rect"></div>
            <div style={{marginRight: "1rem"}}>
                <h3>Компоненты компостера</h3>
                <h6 className="description">Тщательно проанализировав иностранные аналоги, мы создали самое оптимальное устройство для переработки пищевых отходов малого и среднего бизнеса в городах. Конструкция состоит из:
                    <ul>
                        <li>емкости для отходов</li>
                        <li>большого мотора</li>
                        <li>ножей для измельчения</li>
                        <li>карбонового фильтра для борьбы с запахом</li>
                        <li>обогревателя для поддержания температуры</li>
                        <li>контейнера для компоста</li>
                    </ul>
                </h6>
            </div>

            <img id = "composter" src = {composter} alt = "composter"></img>
        </div>
    )
}

export default Composter;